import { render, staticRenderFns } from "./ele.vue?vue&type=template&id=663db931&scoped=true"
var script = {}
import style0 from "./ele.vue?vue&type=style&index=0&id=663db931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663db931",
  null
  
)

export default component.exports